var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import api from "../api";
var AdminUserService = /** @class */ (function () {
    function AdminUserService() {
    }
    AdminUserService.getAllUsers = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(AdminUserService.URI, "/list"), request)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    AdminUserService.getUserById = function (id) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(AdminUserService.URI, "/list"), {
                            id: [id],
                            limit: {
                                offset: 0,
                                limit: 1
                            }
                        })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, (_a = response.data.content) === null || _a === void 0 ? void 0 : _a[0]];
                }
            });
        });
    };
    AdminUserService.createUser = function (user, orgId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(AdminUserService.URI, "/add?orgId=").concat(orgId), user)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    AdminUserService.updateUser = function (user, orgId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(AdminUserService.URI, "/update?orgId=").concat(orgId), user)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    AdminUserService.deleteUser = function (request, orgId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(AdminUserService.URI, "/delete?orgId=").concat(orgId), request)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AdminUserService.loginAs = function (request) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var response, user, organizationId, name_1, lastLoginAsByOrganization;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, api.post("".concat(AdminUserService.URI, "/loginAs"), request)];
                    case 1:
                        response = _b.sent();
                        user = response.data.user;
                        organizationId = (_a = response.data.organization) === null || _a === void 0 ? void 0 : _a.id;
                        if (response.data.token && (user === null || user === void 0 ? void 0 : user.id) && organizationId) {
                            name_1 = [user.firstName, user.lastName].filter(Boolean).join(" ") || user.email || "User";
                            try {
                                lastLoginAsByOrganization = AdminUserService.getLastLoginAsByOrganization();
                                lastLoginAsByOrganization[organizationId] = {
                                    userId: user.id,
                                    organizationId: organizationId,
                                    name: name_1
                                };
                                localStorage.setItem(AdminUserService.LAST_LOGIN_AS_KEY, JSON.stringify(lastLoginAsByOrganization));
                            }
                            catch (e) {
                                console.error("Could not remember the last login-as user", e);
                            }
                        }
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    AdminUserService.getLastLoginAs = function (organizationId) {
        return AdminUserService.getLastLoginAsByOrganization()[organizationId];
    };
    AdminUserService.getLastLoginAsByOrganization = function () {
        var _a;
        try {
            var storedValue = localStorage.getItem(AdminUserService.LAST_LOGIN_AS_KEY);
            if (!storedValue)
                return {};
            var value = JSON.parse(storedValue);
            if (AdminUserService.isLastLoginAs(value)) {
                return _a = {}, _a[value.organizationId] = value, _a;
            }
            return Object.fromEntries(Object.entries(value).filter(function (_a) {
                var entry = _a[1];
                return AdminUserService.isLastLoginAs(entry);
            }));
        }
        catch (e) {
            console.error("Could not read the last login-as user", e);
        }
        return {};
    };
    AdminUserService.isLastLoginAs = function (value) {
        if (!value || typeof value !== "object")
            return false;
        var candidate = value;
        return typeof candidate.userId === "string" &&
            typeof candidate.organizationId === "string" &&
            typeof candidate.name === "string";
    };
    AdminUserService.clearLastLoginAs = function () {
        try {
            localStorage.removeItem(AdminUserService.LAST_LOGIN_AS_KEY);
        }
        catch (e) {
            console.error("Could not clear the last login-as user", e);
        }
    };
    AdminUserService.URI = "/v3/admin/user";
    AdminUserService.LAST_LOGIN_AS_KEY = "admin:lastLoginAs";
    return AdminUserService;
}());
export { AdminUserService };
